import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, Typography } from '@sm/wds-react';

import './Submenu/nav-submenu.scss';

export const SolutionByNeed = ({ title, url }) => {
  return (
    <ListItem
      key={title}
      className="sm-nav-submenu__by-need-container"
      isNavigable
      navigationTarget={url}
    >
      <Typography
        variant="body"
        color="link"
        className="sm-nav-submenu__by-need"
      >
        {title}
      </Typography>
    </ListItem>
  );
};

export default SolutionByNeed;

SolutionByNeed.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
